import React from "react";

const MeetTeam = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g cliPath="url(#clip0_11285_20296)">
        <path
          d="M3.5 21C6.11 16.58 12.46 16.56 15.1 20.95L15.13 21M19.16 20.1C18.74 18.64 17.74 17.5 16.48 17.01L17.67 15.82M14.68 8.4C14.68 9.46 14.38 10.45 13.83 11.29C13.79 11.37 13.74 11.44 13.69 11.51C12.73 12.89 11.12 13.8 9.32001 13.8C6.36001 13.8 3.95001 11.38 3.95001 8.4C3.95001 5.42 6.36001 3 9.32001 3C11.13 3 12.74 3.91 13.69 5.29C13.74 5.36 13.79 5.43 13.83 5.52C14.38 6.36 14.68 7.35 14.68 8.41V8.4ZM20.5 8.4C20.5 10.6 18.73 12.38 16.55 12.38C15.5 12.38 14.55 11.97 13.84 11.29C14.39 10.45 14.69 9.46 14.69 8.4C14.69 7.34 14.39 6.35 13.84 5.51C14.55 4.83 15.5 4.42 16.55 4.42C18.73 4.42 20.5 6.2 20.5 8.4Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_11285_20296">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default MeetTeam;
